/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Andrew Merrill <andrew.merrill@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const GET_DASHBOARD_OVER_TIME = gql`
  query GetDashboardOverTime($input: AdminDashboardOverTimeInput!) {
    dashboardStatOverTime(input: $input) {
      values
      totalValues
      dates
      valueType
    }
  }
`
